export default "__VITE_ASSET__Bd$_zLKv__"